// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"c77c9816","260":"aa564e69","323":"0abb48bd","390":"816bee81","423":"529dc500","449":"49405af9","790":"ea3c6475","854":"9a773208","863":"26745ab1"}[chunkId] + ".chunk.js";
};